import contentRequest from '~/src/api/requests/contentRequest';

export const getTariffs = (providerId, isAuth, additionalParams) => {
    const expand = 'description,features,additionalProducts';
    return contentRequest.get(
        `/v1/internet-tariffs?expand=${expand}&filter[available]=1&filter` +
        `${isAuth ? '[available_client]=1' : '[available_guest]=1'}` +
        `${additionalParams ? additionalParams : ''}` +
        `&providerId=${providerId}`,
    );
};

